import React from "react"
import { getActiveGames } from "GamesStation/gameNames"
import Layout from "GamesStation/Layout"
import ServiceDown from "GamesStation/ServiceDown"
import {
  GridContainer,
  ActiveGames
} from "GamesStation/styled"

import GameList from "GamesStation/GameList"

class GradeList extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      games: [],
      maintenance: false,
      activeGames: getActiveGames() || []
    }
  }

  render() {
    const { maintenance } = this.state

    if (maintenance) {
      return <ServiceDown />
    }

    return (
      <Layout backUrl="/galaxia">
        <GridContainer>
          <ActiveGames>
            <GameList props={this.props} games={this.state.activeGames}></GameList>
          </ActiveGames>
        </GridContainer>

      </Layout>
    )
  }
}

export default GradeList
